import React from 'react';
import { connect } from 'react-redux';
import Modal from "react-modal";
import { RootState } from '../reducers';
import { searchLogTsAction } from '../actions/logTActions';
import MessageDetails from './MessageDetails';
import LogTTable from './LogTTable';
import PrintButton from './PrintButton';
import CSVButton from './CSVButton';
import OverviewSearchForm from './OverviewSearchForm';
import OverviewCsvModal from './OverviewCsvModal';
import { OverviewProps } from './Overview.types';
import { useOverview } from './useOverview';
import 'react-datepicker/dist/react-datepicker.css';
import '../styles/Overview.scss';
import "@aurodesignsystem/auro-button";
import "@aurodesignsystem/auro-icon";
import "@aurodesignsystem/auro-lockup";
import "@aurodesignsystem/design-tokens/dist/tokens/CSSCustomProperties.css"; 


Modal.setAppElement("#root");

const Overview: React.FC<OverviewProps> = (props) => {
  const {
    airline, setAirline, acNumber, flightNumber, payload,
    messageType, setMessageType, startDate, setStartDate,
    endDate, setEndDate, selectedMessage,
    currentPage, setCurrentPage, pageInput, setPageInput,
    showDetails, setShowDetails, isFormValid,
    tableLoading, isSearchLoading,
    isPrintLoading, setIsPrintLoading,
    isCSVLoading, setIsCSVLoading,
    sortColumn, sortDirection, sortLoading,
    searchExecuted, searchAllCriteria,
    fromTo, isXml, setIsXml,
    canSelectAS, canSelectQX,
    lastSearchCriteria,
    showCsvModal, setShowCsvModal,
    csvStartDate, setCsvStartDate, csvEndDate, setCsvEndDate,
    reportType, setReportType, fromToError,
    DatePickereStartDateIsOpen, setDatePickereStartDateIsOpen,
    DatePickereEndDateIsOpen, setDatePickereEndDateIsOpen,
    dateRangeMode, relativeTimeValue, setRelativeTimeValue,
    relativeTimeUnit, setRelativeTimeUnit,
    localLimit, setLocalLimit, calendarViewDate,
    isCSVAuthorized, userData, totalPages, totalCount, logTs, loading,
    advanceCalendarByMonth, navigateToPreviousMonth, navigateToSpecificMonth,
    handleAcNumberChange, handleFlightNumberChange,
    handleKeywordSearchChange, handleFromToChange,
    handleDateRangeModeChange, handleSearch,
    handleRowClick, handleSort,
    handlePageClick, handleNextPage, handlePreviousPage,
    handleGoClick, handleCsvDownload, fetchDataForPagination,
  } = useOverview(props);

  return (
    <div className="overview-wrapper">
      <div className="content-wrapper">

        <OverviewSearchForm
          airline={airline} setAirline={setAirline}
          canSelectAS={canSelectAS} canSelectQX={canSelectQX}
          isXml={isXml} setIsXml={setIsXml}
          acNumber={acNumber} handleAcNumberChange={handleAcNumberChange}
          flightNumber={flightNumber} handleFlightNumberChange={handleFlightNumberChange}
          payload={payload} handleKeywordSearchChange={handleKeywordSearchChange}
          messageType={messageType} setMessageType={setMessageType}
          fromTo={fromTo} handleFromToChange={handleFromToChange}
          handleSearch={handleSearch} isFormValid={isFormValid}
          isSearchLoading={isSearchLoading} fromToError={fromToError}
          dateRangeMode={dateRangeMode} handleDateRangeModeChange={handleDateRangeModeChange}
          relativeTimeValue={relativeTimeValue} setRelativeTimeValue={setRelativeTimeValue}
          relativeTimeUnit={relativeTimeUnit} setRelativeTimeUnit={setRelativeTimeUnit}
          startDate={startDate} setStartDate={setStartDate}
          endDate={endDate} setEndDate={setEndDate}
          DatePickereStartDateIsOpen={DatePickereStartDateIsOpen}
          setDatePickereStartDateIsOpen={setDatePickereStartDateIsOpen}
          DatePickereEndDateIsOpen={DatePickereEndDateIsOpen}
          setDatePickereEndDateIsOpen={setDatePickereEndDateIsOpen}
          calendarViewDate={calendarViewDate}
          navigateToPreviousMonth={navigateToPreviousMonth}
          advanceCalendarByMonth={advanceCalendarByMonth}
          navigateToSpecificMonth={navigateToSpecificMonth}
        />

        <div className="right-section">
          {(isPrintLoading || isCSVLoading) ? null : (
            <div className="table-header-controls">
              <div className="left-controls">
                <label htmlFor="pageSize" className="page-size-label hide-button">Show </label>
                <select
                  id="pageSize" 
                  value={localLimit}
                  onChange={(e) => {
                    const newLimit = Number.parseInt(e.target.value, 10);
                    setLocalLimit(newLimit);
                    if (lastSearchCriteria) {
                      setCurrentPage(1);
                      setPageInput("1");
                      fetchDataForPagination({ ...lastSearchCriteria, Page: 1, Limit: newLimit });
                    }
                  }}
                  className="page-size-select hide-button"
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
              </div>
              <div className="right-controls">
                <div className="icon-divider print-button">
                  <PrintButton 
                    searchCriteria={searchAllCriteria} 
                    searchExecuted={searchExecuted} 
                    user={userData}
                    onLoadingChange={setIsPrintLoading}
                  />
                </div>
                {isCSVAuthorized && (
                  <div className="icon-divider csv-button">
                    <CSVButton 
                      searchCriteria={searchAllCriteria} 
                      searchExecuted={searchExecuted} 
                      user={userData}
                      onLoadingChange={setIsCSVLoading}
                    />
                  </div>
                )}
                {isCSVAuthorized && (
                  <div className="icon-divider">
                    <button 
                      className='userhistory-button' 
                      onClick={() => setShowCsvModal(true)}
                    >
                      Users History Report
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}

          {(isPrintLoading || isCSVLoading) ? (
            <div className="operation-loading-message">
              {isPrintLoading 
                ? 'Preparing print output, please wait…' 
                : 'Exporting CSV file, please wait…'}
            </div>
          ) : (
            <LogTTable
              logTs={logTs}
              onRowClick={handleRowClick}
              selectedMessage={selectedMessage}
              onSort={handleSort}
              sortColumn={sortColumn}
              sortDirection={sortDirection}
              sortLoading={sortLoading}
              loading={tableLoading}
            />
          )}
         
          <span>
            {logTs && logTs.length > 0 && !isPrintLoading && !isCSVLoading && (
              <div className="pagination-container simplified">
                {totalCount > 0 && (
                  <span className="results-count-info">
                    Showing {totalCount} results
                  </span>
                )}
                <div className="pagination-buttons">
                  <button
                    className={`pagination-button prev-button ${currentPage === 1 ? "hidden" : ""}`}
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                    style={{ visibility: currentPage === 1 ? 'hidden' : 'visible' }}
                  >
                    &lt; Previous
                  </button>
                  <span className="pagination-info">
                    Page {currentPage}
                  </span>
                  <button
                    className="pagination-button next-button"
                    onClick={handleNextPage}
                    disabled={!logTs || logTs.length < localLimit}
                  >
                    Next &gt;
                  </button>
                </div>
              </div>
            )}
          </span>

          {showDetails && selectedMessage && (
            <div
              className="message-details show"
              role="button"
              tabIndex={0}
              onClick={(e) => {
                if (e.target === e.currentTarget) {
                  setShowDetails(false);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setShowDetails(false);
                }
              }}
            >
              <div className="message-details-inner">
                <MessageDetails logT={selectedMessage} onClose={() => setShowDetails(false)} />
              </div>
            </div>
          )}

          {!loading && searchExecuted && (!logTs || logTs.length === 0) && (
            <div className="no-results">
              <p>No results found.</p>
            </div>
          )}
        </div>

      </div>

      <OverviewCsvModal
        showCsvModal={showCsvModal} setShowCsvModal={setShowCsvModal}
        csvStartDate={csvStartDate} setCsvStartDate={setCsvStartDate}
        csvEndDate={csvEndDate} setCsvEndDate={setCsvEndDate}
        reportType={reportType} setReportType={setReportType}
        handleCsvDownload={handleCsvDownload} isCSVLoading={isCSVLoading}
      />

    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  logTs: state.logTReducer.logts,
  loading: state.logTReducer.loading,
  error: state.logTReducer.error,
  page: state.logTReducer.page,
  limit: state.logTReducer.limit,
  totalPages: state.logTReducer.totalPages,
  totalCount: state.logTReducer.totalCount,
});

const mapDispatchToProps = {
  searchLogTs: searchLogTsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Overview);
